import axios from "axios";
import Session from "../storage/local/Session";

export default class Api {
  _config = {};
  _authHeaders = {
    'Authorization': `Bearer ${Session.accessToken}`,
  };

  static get instance() {
    return new Api();
  }

  get authHeaders() {
    return this._authHeaders;
  }

  get baseUrl() {
    if (process && process.env && process.env.REACT_APP_API_BASEURL) {
      return process.env.REACT_APP_API_BASEURL;
    }

    return '/api';
  }

  auth() {
    if (!this._config.headers) {
      this._config.headers = {};
    }

    this._config.headers = Object.assign({}, this._config.headers, this.authHeaders);

    return this;
  }

  prepareData(data) {
    return Object.assign({}, data);
  }

  prepareConfig(config) {
    return Object.assign({baseURL: this.baseUrl}, this._config, config);
  }

  post(url, data, config) {
    return axios.post(url, this.prepareData(data), this.prepareConfig(config));
  }

  get(url, config) {
    return axios.get(url, this.prepareConfig(config));
  }

  put(url, data, config) {
    return axios.put(url, this.prepareData(data), this.prepareConfig(config));
  }

  delete(url, config) {
    return axios.delete(url, this.prepareConfig(config));
  }
}
